import React, {useEffect, useState} from "react";
import {Box, Button, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import OpenInNew from "@mui/icons-material/OpenInNew";
import {api} from "../../../../../api/API";
import {ElevationFile} from "./ElevationSidebarContext";

// a cell's file (a legacy file-based elevation, a wall type, …): the value's name and the file,
// shown inline. A pair's door elevation may have a file per leaf.
export function ElevationSidebarFile(props: {
    // what the file is, e.g. "Wall Type".
    label: string;
    openingName: string;
    // the cell's value.
    name: string;
    files: ElevationFile[];
}) {
    const files = props.files;
    const [fileId, setFileId] = useState<number | null>(files[0]?.file ?? null);

    // another opening or file set: show its first file.
    useEffect(() => {
        setFileId(files[0]?.file ?? null);
    }, [files]);

    const file = files.find(f => f.file === fileId) ?? files[0] ?? null;

    return (
        <>
            <Box sx={{px: 1, py: 0.75, borderBottom: "1px solid " + grey["300"], flexShrink: 0}}>
                <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                    <Box sx={{flex: 1, minWidth: 0}}>
                        <Typography sx={{fontSize: 13, fontWeight: 600, lineHeight: 1.3}} noWrap>
                            {props.openingName}
                        </Typography>
                        <Typography sx={{fontSize: 11, color: "text.secondary", lineHeight: 1.3}} noWrap>
                            {props.label}: {props.name || "—"}
                            {file?.fileName ? ` · ${file.fileName}` : ""}
                        </Typography>
                    </Box>
                    {files.length > 1 && (
                        <ToggleButtonGroup
                            size="small"
                            exclusive
                            value={file?.file ?? null}
                            onChange={(e, value: number | null) => value !== null && setFileId(value)}
                            sx={{"& .MuiToggleButton-root": {py: 0, px: 1, fontSize: 11, textTransform: "none"}}}
                        >
                            {files.map(f => <ToggleButton key={f.file} value={f.file}>{f.label}</ToggleButton>)}
                        </ToggleButtonGroup>
                    )}
                    {file && (
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<OpenInNew />}
                            href={api.files.downloadLink(file.file, "inline")}
                            target="_blank"
                            rel="noreferrer"
                            sx={{flexShrink: 0, whiteSpace: "nowrap"}}
                        >
                            Open
                        </Button>
                    )}
                </Box>
            </Box>
            {file ? (
                <iframe
                    title={props.label}
                    src={api.files.downloadLink(file.file, "inline")}
                    style={{flex: 1, width: "100%", border: "none", minHeight: 0}}
                />
            ) : (
                <div style={{padding: 12, fontSize: 12, color: grey["600"]}}>
                    No file uploaded for this {props.label.toLowerCase()}.
                </div>
            )}
        </>
    );
}
